import { render, staticRenderFns } from "./achors.vue?vue&type=template&id=63f64928&"
import script from "./achors.vue?vue&type=script&lang=js&"
export * from "./achors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports